// Mallow — cart bundle upgrade.
// Swaps a cart line for its bundle variant in one click.
// Deliberate order: ADD the bundle first, THEN remove the old line.
// If the second call fails the shopper has both items (recoverable) rather
// than an emptied cart (not recoverable).
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mallow-upgrade]');
    if (!button) return;
    event.preventDefault();
    if (button.dataset.busy === 'true') return;
    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');

    var addUrl = button.dataset.addUrl;
    var changeUrl = button.dataset.changeUrl;
    var cartUrl = button.dataset.cartUrl;
    var targetId = button.dataset.targetVariant;
    var oldKey = button.dataset.oldKey;

    var post = function (url, payload) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
    };

    post(addUrl + '.js', { items: [{ id: targetId, quantity: 1 }] })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return post(changeUrl + '.js', { id: oldKey, quantity: 0 });
      })
      .then(function () { window.location.href = cartUrl; })
      .catch(function () { window.location.href = cartUrl; });
  });
})();
